<script lang="ts">
	import type { Content } from '@prismicio/client';
	import { PrismicRichText, type SliceComponentProps } from '@prismicio/svelte';
	import Label from './Label.svelte';

	type Props = SliceComponentProps<Content.RichTextSlice>;

	const { slice }: Props = $props();

	const alignment = slice.primary.alignment ? slice.primary.alignment.toLowerCase() : 'start';
	const columns = slice.primary.width ? parseInt(slice.primary.width) : 12;
	const hdColumns = columns < 12 ? columns + 1 : columns;
</script>

<section
	class="rich-text spacing-top-{slice.primary.spacing_top} spacing-bottom-{slice.primary
		.spacing_bottom}"
	data-slice-type={slice.slice_type}
	data-slice-variation={slice.variation}
>
	<div class="container">
		<div class="row justify-content-{alignment}">
			<div class="col-12 col-lg-{columns} col-hd-{hdColumns}">
				<div class="rich-text__content text-{alignment}" class:lead={slice.primary.lead_text}>
					<PrismicRichText
						field={slice.primary.content}
						components={{
							label: Label
						}}
					/>
				</div>
			</div>
		</div>
	</div>
</section>
